import { useEffect, useState } from 'react';
import { resolveProxyWsUrl, withWsToken } from './proxyWs';

// Read-only view of the proxy's IU-rewrite rule state (WS `iu_rules`).
// Opens a socket only while `active`; returns null until the first frame
// arrives (callers must treat null as "state not yet known", not "off").
// Pattern: IuRewritePage.jsx own-WebSocket effect.
export default function useIuRules(active) {
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!active) { setState(null); return undefined; }
    let ws;
    let dead = false;
    let timer = null;
    function connect() {
      if (dead) return;
      try {
        ws = new WebSocket(withWsToken(resolveProxyWsUrl()));
      } catch {
        timer = setTimeout(connect, 3000);
        return;
      }
      ws.onopen = () => {
        try { ws.send(JSON.stringify({ type: 'get_iu_rules' })); } catch { /* ignore */ }
      };
      ws.onmessage = (evt) => {
        try {
          const msg = JSON.parse(evt.data);
          if (msg && msg.type === 'iu_rules' && msg.data) {
            setState({
              enabled: !!msg.data.enabled,
              rules: Array.isArray(msg.data.rules) ? msg.data.rules : [],
            });
          }
        } catch { /* ignore */ }
      };
      ws.onclose = () => { if (!dead) timer = setTimeout(connect, 3000); };
      ws.onerror = () => { try { ws.close(); } catch { /* ignore */ } };
    }
    connect();
    return () => {
      dead = true;
      if (timer) clearTimeout(timer);
      try { ws && ws.close(); } catch { /* ignore */ }
    };
  }, [active]);

  return active ? state : null;
}
